export * from './primeng-video-dialog.component';